module.exports = __webpack_public_path__ + "img/electronic_electric_use_selected.dae4c33a.svg";